/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import ThemeIconProvider from './ThemeIconProvider';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) System ViewList Icon component.
 */
export const SystemViewListIcon = ({size, color}: IconProps) => {
  const {iconSize, iconColor} = useIconDLS({size, color});
  return (
    <ThemeIconProvider name='SystemViewListIcon' size={size} color={color} legacyIcon={(
      <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none'>
        <path d='M5.75 5.95831H23' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round' />
        <path d='M5.75 11.9999H23' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round' />
        <path d='M5.75 18H23' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round' />
        <path d='M1.00559 7.01117C1.56096 7.01117 2.01117 6.56096 2.01117 6.00559C2.01117 5.45022 1.56096 5 1.00559 5C0.450216 5 0 5.45022 0 6.00559C0 6.56096 0.450216 7.01117 1.00559 7.01117Z' fill={iconColor} />
        <path d='M1.00559 13.0112C1.56095 13.0112 2.01117 12.561 2.01117 12.0056C2.01117 11.4502 1.56095 11 1.00559 11C0.450216 11 0 11.4502 0 12.0056C0 12.561 0.450216 13.0112 1.00559 13.0112Z' fill={iconColor} />
        <path d='M1.00559 19.0112C1.56095 19.0112 2.01117 18.561 2.01117 18.0056C2.01117 17.4502 1.56095 17 1.00559 17C0.450216 17 0 17.4502 0 18.0056C0 18.561 0.450216 19.0112 1.00559 19.0112Z' fill={iconColor} />
      </svg>
    )} />
  );
};
